<template>
  <v-icon
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </v-icon>
</template>

<script>
export default {
  name: "EkitabuIcon",
  inheritAttrs: false,
};
</script>
